<template>
	<div>
		<template>
			<v-btn
				slot="actions"
				color="#f03573"
				btn
				v-bind="$attrs"
				:width="maxSize"
				height="27"
				@click="decideOnAction"
				depressed
				class="assistant"
				rounded
			>
				<span :class="textClasses" v-if="showMyGamesText">{{ $t("toolbar.mygames") }}</span>
				<span :class="textClasses" v-else>{{ $t("toolbar.create") }}</span>
			</v-btn>
		</template>
		<upgrade-dialog v-model="showUpgrade" />
	</div>
</template>

<script>
import UpgradeDialog from "../view/plans/UpgradeDialog";

export default {
	name: "CreateGameBtn",
	components: { UpgradeDialog },
	data() {
		return {
			showUpgrade: false
		};
	},
	computed: {
		breakPoint(){
			return this.$vuetify.breakpoint.name;
		},
		maxSize(){
			switch (this.breakPoint){
			case "xs":
				return "110";
			case "sm":
				return "130";
			case "md":
				return "180";
			default:
				return "227";
			}
		},
		textClasses(){
			return "assistant d-inline-block";
		},
		canCreateGame() {
			return this.$store.getters.canCreateGame;
		},
		isCreateGameScreen() {
			return this.$store.getters.isCreateGameScreen;
		},
		isTypeSelectionPage(){
			return this.route.name === "types-circles";
		},
		route() {
			return this.$route;
		},
		isNew() {
			return this.game.id === undefined;
		},
		showMyGamesText(){
			return this.isCreateGameScreen || this.isTypeSelectionPage;
		}
	},

	methods: {
		decideOnAction(){
			if(this.showMyGamesText){
				this.goToGamesPage();
			}
			else{
				this.checkGamesLimit();
			}
		},
		checkGamesLimit() {
			if (this.canCreateGame) {
				this.$router.push({ name: "types-circles" });
			} else {
				this.showUpgrade = true;
			}
		},
		goToGamesPage() {
			this.$router.push({ name: "games-page" });
		}
	},
	created() {}
};
</script>

<style scoped lang="scss">
.assistant {
  font-family: Assistant, sans-serif;
  font-style: normal;
  color: #fff;
  font-size: min(1.8vw,22px) !important;
  @media(min-width: 600px) {
    font-size: min(1.4vw,22px) !important;
  }

  @media(min-width: 960px) {
    font-size: min(1.3vw,22px) !important;
  }

  @media(min-width: 1264px) {
    font-size: min(1.1vw,22px) !important;
  }
}
</style>
